// import { useAuthStore } from '@/stores/auth'

export function setupRouterGuards(router) {
  // 全局前置守卫
  router.beforeEach(async (to, from, next) => {
    const hasToken = localStorage.getItem('token');

    if (hasToken) {
      // 1. 已登录：禁止访问登录页，直接进入目标页
      if (to.path === "/login") {
        next("/"); // 跳转到首页
      } else {
        next();
      }
    } else {
      // 2. 未登录：只能访问白名单页面（如/login），否则跳转登录
      const whiteList = ["/login", "/404"];
      if (whiteList.includes(to.path)) {
        next(); // 白名单页面直接访问
      } else {
        next("/login"); // 非白名单 → 跳转到登录页
      }
    }
  });

  // 全局后置钩子
  router.afterEach(() => {
    // 可以在这里添加页面加载完成后的逻辑
  });
}
